import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { UserService } from '../auth/_services/user.service';
import { LayoutUtilsService, MessageType } from "../_base/crud";
import { SystemModel } from '../configuration/_models/system.model';
import { catchError, takeUntil } from 'rxjs/operators';
import { Papa } from "ngx-papaparse";
import { of, pipe, Subject, throwError } from 'rxjs';
import { cloneDeep } from 'lodash';


const API_URL = environment.API_URL;
const SIMULATE_PREDICTION = '/prediction/simulate';
const EXPLAIN_PREDICTION = '/prediction/explain-prediction';
const SHOW_EXPLAIN = '/prediction/show-explain';
const SIMULATE_PROJECTION = '/api/prediction/simulate_projection';

@Injectable({
  providedIn: 'root'
})
export class SystemDetailsService {
  xaxisScroll: Number;
  PYTHON_API_URL;
  d_exist_range:any = {
    from: '',
    to: ''
  };
  scrollTagGraphsApiCall =  new EventEmitter<any>();
  fieldListForSAP = "NotificationNo,Order,ChangedOn,CompletedOn,CompletedByName,CreatedBy,CreatedByName,CreatedOn,Description,Equipment,EquipmentDesc,FunctionalLoc,NotificationType,PlanGroup,PlanGroupDesc,Notifdate,DamageDesc,Effect,PlantSection,Status,UserStatus,MaintenancePlant,ABCindic,MalfunctStart,MalfuncEnd,Flocaffected,Priority,BreakdownDuration,Costs,REQUIRED_END_DATETIME,REQUIRED_START_DATETIME,alert,failure";
  constructor(
    public http: HttpClient,
    private readonly userService: UserService,
    private readonly layoutUtilsService: LayoutUtilsService,
    private readonly papa: Papa
  ) {
    this.PYTHON_API_URL = environment.runtime.PYTHON_API_URL;
  }
  ngUnsubscribe: Subject<void> = new Subject<void>();
  assetSelectedTagListChanged = new EventEmitter<any[]>();
  systemAnomalyDataChanged = new EventEmitter<any>();
  maintenanceDataChanged = new EventEmitter<any>();
  maintenanceOnedataChanged = new EventEmitter<any>();
  heatMapDataChanged = new EventEmitter<any>();
  topAnomalyContributorsChanged = new EventEmitter<any[]>();
  topAnomalyContributorsInTimeRangeChanged = new EventEmitter<any[]>();
  tagDirectionalityChanged = new EventEmitter<any[]>();
  actualVsPredictedChanged = new EventEmitter<any[]>();
  tagValueInRangeChanged = new EventEmitter<any[]>();
  addFailureModeNotification = new EventEmitter<any[]>();
  assetSelectionChanged = new EventEmitter<any[]>();
  tagSelectionChanged = new EventEmitter<any[]>();
  selectedSystemChange = new EventEmitter<SystemModel>();

  changeThreshold = new EventEmitter<any[]>();
  showSimulationPanel = new EventEmitter<{}>();
  clearSimulation = new EventEmitter<{}>();

  updateCurrentValueForTags = new EventEmitter<any>();

  simulatedAnomalyScoreChanged = new EventEmitter<any[]>();
  failureModeSelection: boolean = false;
  heatMapData: any = [];
  healthConfig: any;
  anomalyScoreData: any;
  healthCalculations: any;
  sapData : any;

  anomalyClickedPoint: any;
  simulationButtonDisabled: Boolean = true;
  getSystemAnomalyScoreApiCallPending = false

  //table = this.activatedRoute.snapshot.queryParamMap.get('table')?this.activatedRoute.snapshot.queryParamMap.get('table'):'prt';
  table = '';
  user = JSON.parse(localStorage.getItem('user'));

  setAnomalyScoreData = anomalyScoreData => this.anomalyScoreData = anomalyScoreData
  getAnomalyScoreData = () => this.anomalyScoreData

  setHealthCalculations(healthCalc) {
    this.healthCalculations = healthCalc;
  }
  getHeatlhCalculations = () => this.healthCalculations

  setHealthConfig(healthConfig = []) {
    this.healthConfig = healthConfig;
  }
  getHealthConfig = () => this.healthConfig;

  getSystemAnomalyScore(range: any = {}, c_s = 1, tsTable = null) {
    const resolvedTable = tsTable || this.table;
    if (!resolvedTable) {
      this.getSystemAnomalyScoreApiCallPending = false;
      return;
    }
    let url = API_URL + `/api/getSystemAnomalyScore?table=` + resolvedTable + '&c_s=' + c_s
    this.getSystemAnomalyScoreApiCallPending = true
    if (range.from && range.to)
      url += '&from=' + encodeURIComponent(range.from) + '&to=' + encodeURIComponent(range.to)
    else if (this.user.nondemo)
      url += '&nondemo=1'

    this.http.get(url, {headers: this.userService.getHttpAuthHeader()})
    .pipe( takeUntil(this.ngUnsubscribe) )
    .subscribe((data: any) => {
      this.getSystemAnomalyScoreApiCallPending = false
      let res = {
        data: data,
        left: false
      }
      this.systemAnomalyDataChanged.emit(res);
    }, error => {
      this.getSystemAnomalyScoreApiCallPending = false
      let res = {
        data: [],
        left: false
      }
      this.systemAnomalyDataChanged.emit(res);
      console.log(error.status, error.error.message);
    });
  }

  /** Fetch pre-aggregated uptime % from backend (no raw series). */
  getSystemUptime(tsTable: string,range: any = {}) {
    if (!tsTable) {
      return of({ status: 200, message: 'Success', data: { uptime: null } });
    }
    let params = new HttpParams().set('table', tsTable);
    if (range?.from && range?.to) {
      // DateService may pass Date objects; backend expects ISO (not locale Date#toString).
      const from = range.from instanceof Date ? range.from.toISOString() : String(range.from);
      const to = range.to instanceof Date ? range.to.toISOString() : String(range.to);
      params = params.set('from', from).set('to', to);
    } else if (this.user?.nondemo) {
      params = params.set('nondemo', '1');
    }
    return this.http.get(`${API_URL}/api/get-system-uptime`, {
      headers: this.userService.getHttpAuthHeader(),
      params
    }).pipe(
      catchError(error => {
        console.log(error.status, error.error?.message);
        return of({ status: 500, message: 'Internal server error', data: { uptime: null } });
      })
    );
  }

  getSystemAnomalyScoreonScroll(range: any = {}, c_s = 1) {
    if (!this.table) {
      this.getSystemAnomalyScoreApiCallPending = false;
      return;
    }
    let url = API_URL + `/api/getSystemAnomalyScore?table=` + this.table + '&c_s=' + c_s
    this.getSystemAnomalyScoreApiCallPending = true
    if (range.from && range.to)
      url += '&from=' + encodeURIComponent(range.from) + '&to=' + encodeURIComponent(range.to)
    else if (this.user.nondemo)
      url += '&nondemo=1'

    this.http.get(url, {headers: this.userService.getHttpAuthHeader()})
    .pipe( takeUntil(this.ngUnsubscribe) )
    .subscribe((data: any) => {
      this.getSystemAnomalyScoreApiCallPending = false
      let res = {
        data: data,
        left: true
      }
      this.systemAnomalyDataChanged.emit(res);
    }, error => {
      this.getSystemAnomalyScoreApiCallPending = false
      let res = {
        data: [],
        left: true
      }
      this.systemAnomalyDataChanged.emit(res);
      console.log(error.status, error.error.message);
    });
  }

  replaceAliasWithTag(data, alias){
    let res = []
    for(let i = 0; i < data.length; i++){
      let obj = {}
      Object.keys(data[i]).forEach(key => {
        if(alias[key])
          obj[alias[key]] = data[i][key]
        else obj[key] = data[i][key]
      })
      res.push(obj)
    }
    return res
  }

  getContributingTags(tagList, assetList, range: any = {}, left = false) {
    let url = API_URL + `/api/getContributingTags?table=` + this.table;
    if (tagList.length)
      url += '&tag=' + encodeURIComponent(tagList)
    else if (assetList.length)
      url += '&asset=' + assetList

    if (range.from && range.to)
      url += '&from=' + encodeURIComponent(range.from) + '&to=' + encodeURIComponent(range.to)
    else if (this.user.nondemo)
      url += '&nondemo=1'

    this.http.get(url, {headers: this.userService.getHttpAuthHeader()}).pipe( takeUntil(this.ngUnsubscribe) ).subscribe((data: any) => {
      this.heatMapData = [...this.heatMapData, ...this.replaceAliasWithTag(data.data, data.alias)]
      //this.heatMapData = this.replaceAliasWithTag(data.data, data.alias)
      let res = {
        data: data,
        left: left
      }
      this.heatMapDataChanged.emit(res);
    }, error => {
      let res = {
        data: [],
        left: left
      }
      this.heatMapDataChanged.emit(res);
      console.log(error.status, error.error.message);
    });
  }

  getContributingTagsOnScroll(tagList, assetList, range: any = {}) {
    let url = API_URL + `/api/getContributingTags?table=` + this.table;
    if (tagList.length)
      url += '&tag=' + encodeURIComponent(tagList)
    else if (assetList.length)
      url += '&asset=' + assetList

    if (range.from && range.to)
      url += '&from=' + encodeURIComponent(range.from) + '&to=' + encodeURIComponent(range.to)
    else if (this.user.nondemo)
      url += '&nondemo=1'

    this.http.get(url, {headers: this.userService.getHttpAuthHeader()}).pipe( takeUntil(this.ngUnsubscribe) ).subscribe((data: any) => {
      this.heatMapData = [...this.replaceAliasWithTag(data.data, data.alias), ...this.heatMapData]
      let res = {
        data: data,
        left: true
      }
      this.heatMapDataChanged.emit(res);
    }, error => {
      let res = {
        data: [],
        left: true
      }
      this.heatMapDataChanged.emit(res);
      console.log(error.status, error.error.message);
    });
  }

  getTopAnomalyContributors(point) {
    let url = API_URL + `/api/getTopAnomalyContributors?table=` + this.table;
    if (typeof point == 'object') {
      url = url + '&from=' + point.from + '&to=' + point.to
    }
    else {
      url = url + '&time=' + point
    }
    this.http.get(url, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.topAnomalyContributorsChanged.emit(cloneDeep(data));
    }, error => {
      this.topAnomalyContributorsChanged.emit([]);
      console.log(error.status, error.error.message);
    })

  }

  getTopAnomalyContributorsInTimeRange(range) {
    let url = API_URL + `/api/getTopAnomalyContributorsInTimeRange?table=` + this.table + '&stime=' + range.s + '&etime=' + range.c;
    this.http.get(url, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.topAnomalyContributorsInTimeRangeChanged.emit(data);
    }, error => {
      this.topAnomalyContributorsInTimeRangeChanged.emit([]);
      console.log(error.status, error.error.message);
    });
  }

  getTagDirectionality(range) {
    let url = API_URL + `/api/getTagDirectionality?table=` + this.table + '&from=' + range.s + '&to=' + range.c;
    this.http.get(url, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.tagDirectionalityChanged.emit(data);
    }, error => {
      this.tagDirectionalityChanged.emit([]);
      console.log(error.status, error.error.message);
    })
  }

  getTagAverage(options) {
    let url = API_URL + `/api/tag_average`;
    let params = options;
    return this.http.get(url, {params, headers: this.userService.getHttpAuthHeader()});
  }

  /* Deprecated */
  getActualVsPredicted(point) {
    let url = API_URL + `/api/getTagAnomalyScore?table=` + this.table + '&time=' + point;
    this.http.get(url, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.actualVsPredictedChanged.emit(data[0])
    }, error => {
      this.actualVsPredictedChanged.emit([]);
      console.log(error.status, error.error.message);
    });
  }

  downloadDqReport(range: any = {}) {
    let url = API_URL + `/api/dataQualityReport?tsTable=` + this.table + '&origin=web';
    if (range.from && range.to)
      url += '&from=' + encodeURIComponent(range.from) + '&to=' + encodeURIComponent(range.to)
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader(), responseType: 'text'}).subscribe(res=>{
      this.papa.parse(res, {
        header: true,
        complete: (results) => {
          const csv = this.papa.unparse(results.data);
          const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const csvURL = window.URL.createObjectURL(csvData);
          const a = document.createElement('a');
          a.href = csvURL;
          a.download = 'Data Quality_' + new Date().toISOString().split('T')[0] + '.csv';
          a.click();
        }
      });
    })
  }

  searchTags(s: string) {
    let url = environment.API_URL + `/api/tag/search?q=` + s
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader() });
  }

  getTagData(tagId, tagMongoId, range, raw = 0, tsTable = '', systemId = null){
    const resolvedTable = tsTable || this.table;
    let params = new HttpParams();

    params = params.set('table', resolvedTable);
    params = params.set('tagactual', tagId);
    params = params.set('tagMongoId', tagMongoId);

    if (range.from && range.to) {
      params = params.set('from', range.from);
      params = params.set('to', range.to);
    } else if (this.user.nondemo) {
      params = params.set('nondemo', '1');
    }

    if (systemId && systemId !== '') {
      params = params.set('systemId', systemId);
    }

    params = params.set('raw', raw === 1 ? '1' : '0');

    const url = environment.API_URL + `/api/tagActualVsPredicted`;
    return this.http.get(url, {
      params,
      headers: this.userService.getHttpAuthHeader()
    });
  }

  getForecastProjectionData(tagId: any, tsTable = '', failureMode?: string, kind: 'ttf' | 'tti' = 'ttf') {
    const httpParams = new HttpParams({
      fromObject: {
        table: tsTable || this.table,
        tagactual: tagId,
        ...(failureMode && { fm_id: failureMode }),
      },
    });

    const endpoint = kind === 'tti' ? 'generate_projection_tti' : 'generate_projection';
    const url = `${environment.API_URL}/api/prediction/${endpoint}`;
    return this.http.get(url, {
      headers: this.userService.getHttpAuthHeader(),
      params: httpParams,
    });
  }

  simulateProjection(tagId: any, tsTable = '', failureMode?: string, calAt?: Date | string) {
    const body = {
      table: tsTable || this.table,
      tagactual: tagId,
      ...(failureMode && { fm_id: failureMode }),
      ...(calAt && { cal_at: calAt instanceof Date ? calAt.toISOString() : calAt }),
    };

    const url = `${API_URL}${SIMULATE_PROJECTION}`;
    return this.http.post(url, body, {
      headers: this.userService.getHttpAuthHeader(),
    });
  }

  getTagRawData(tsTable, tagId, range: any = {}, dqalert = 0, raw = 1) {
    if (!tsTable)
      tsTable = this.table;
    let url = API_URL + '/api/tag/raw?tsTable=' + tsTable + '&tag=' + encodeURIComponent(tagId);
    if (range.from)
      url += '&from=' + encodeURIComponent(range.from);
    if (range.to)
      url += '&to=' + encodeURIComponent(range.to);
    if(dqalert == 1)
      url += '&dqalert=' + dqalert;
    if (raw)
      url += '&raw=' + raw;
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader() })
  }
  getGroupedTagData(tsTable, tagIds, range: any = {}, shutdownIdx = 0, raw = 1) {
    if (!tsTable)
      tsTable = this.table;
    let url = API_URL + '/api/v2/tag/raw'
    const reqBody = {
      tsTable,
      tags: tagIds,
      from: range.from,
      to: range.to,
      raw,
      shutdownIdx
    }
    return this.http.post(url, reqBody, { headers: this.userService.getHttpAuthHeader() })
  }
  getTagCalculatedData(tsTable, tagId, range: any = {}) {
    let url = this.PYTHON_API_URL + '/pyapi/tag/calculation?tsTable=' + tsTable + '&_id=' + encodeURIComponent(tagId);
    if (range.from)
      url += '&from=' + encodeURIComponent(range.from);
    if (range.to)
      url += '&to=' + encodeURIComponent(range.to);
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader() })
  }

  getTagValueInRange(tag, range, compare) {
    let url = API_URL + `/api/tagActualVsPredicted?table=` + this.table + '&tagactual=' + encodeURIComponent(tag) + '&from=' + range.fromDate.toISOString() + '&to=' + range.toDate.toISOString();

    if (compare)
      url += '&compare=1';
    this.http.get(url, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.tagValueInRangeChanged.emit(data)
    }, error => {
      this.tagValueInRangeChanged.emit([]);
      console.log(error.status, error.error.message);
    });
  }
  simulatePrediction = (payload) => {
    let url = this.PYTHON_API_URL + SIMULATE_PREDICTION
    return this.http.post(url, payload)
  }

  getAlertPredictionStatus =(params) => {
    let url = `${API_URL}/api/prediction/alterPredictionStatus`;
    return this.http.get(url,{params, headers: this.userService.getHttpAuthHeader()})
  }

  getFailureRange = (params) => {
    let url = API_URL + '/api/failurerange';
    return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() });
  }

  getAlertCount = (params = {}) => {
    let url = API_URL + '/api/alert/count';
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader() });
  }

  showExplantion(tag, date, system, txId = '') {
    if (txId) {
      let url = API_URL + `/pyapi/explanation?id=` + txId + '&tagId=' + tag + '&recordTimestamp=' + new Date(date.x).toISOString();
      return this.http.get(url, { headers: this.userService.getHttpAuthHeader() })
    }
    else {
      const httpParams = new HttpParams({
        fromObject: {
          tsTable: system.tsTable,
          tagId: tag,
          recordTimestamp: new Date(date.x).toISOString(),
        },
      });
      const url = `${API_URL}${EXPLAIN_PREDICTION}`;
      return this.http.get(url, { headers: this.userService.getHttpAuthHeader(), params: httpParams });
    }
  }

  checkShapEligibility(system, tagId, recordTimestamp, tagActual, tagPredicted) {
    const httpParams = new HttpParams({
      fromObject: {
        tsTable: system.tsTable,
        tagId,
        recordTimestamp: new Date(recordTimestamp).toISOString(),
        ...(tagActual && { tagActual }),
        ...(tagPredicted && { tagPredicted }),
      },
    });

    const url = `${API_URL}${SHOW_EXPLAIN}`;
    return this.http.get(url, {
      headers: this.userService.getHttpAuthHeader(),
      params: httpParams,
    });
  }

  showToastMessage(_saveMessage ){
    this.layoutUtilsService.showActionNotification(_saveMessage, MessageType.Create, 10000, true);
  }

  getMaintenanceData(params = {}, fields = null) {
    let httpParams = new HttpParams({ fromObject: params });
    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }
    let url = API_URL + '/api/sap';
    this.http.get(url, {
      headers: this.userService.getHttpAuthHeader(),
      params: httpParams,
    })
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
      this.maintenanceDataChanged.emit(data.data);
      this.sapData = data.data;
    }, error => {
      this.maintenanceDataChanged.emit([]);
      console.log(error.status, error.error.message);
    });
  }
}
